document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('calc-form');
  const resultDiv = document.getElementById('result');
  const t = (key) => (window.i18nCoolingCalc && window.i18nCoolingCalc[key]) || key;

  function altitudeCoeff(h) {
    if (h <= 100) return 3.10;
    if (h <= 250) return 3.20;
    if (h <= 500) return 3.30;
    if (h <= 750) return 3.40;
    if (h <= 1000) return 3.50;
    if (h <= 1250) return 3.60;
    if (h <= 1500) return 3.80;
    if (h <= 2000) return 4.10;

    return 3.10;
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const ambient   = parseFloat(document.getElementById('ambientTemp').value);
    const internal  = parseFloat(document.getElementById('internalTemp').value);
    const powerLoss = parseFloat(document.getElementById('powerLoss').value);
    const altitude  = parseFloat(document.getElementById('altitude').value);

    if (isNaN(ambient) || isNaN(internal) || isNaN(powerLoss) || isNaN(altitude)) {
      showResult(`<p>${t('fill_all')}</p>`, true);
      return;
    }

    if (internal <= ambient) {
      showResult(`<p>${t('temp_error')}</p>`, true);
      return;
    }

    const deltaT = internal - ambient;        
    const k_a  = altitudeCoeff(altitude);
    const airFlowNeeded = Math.round((powerLoss/deltaT*k_a));

    const html = `
      <div class="result-box">
        <p class="value">${airFlowNeeded.toFixed(1)} <span>m³/h</span></p>
        <p class="label">${t('label')}</p>
        <p class="note">${t('note')}</p>
      </div>
    `;
    showResult(html, false);
  });

  function showResult(html, isError) {
    resultDiv.innerHTML = html;
    resultDiv.style.opacity = "0";
    resultDiv.style.transition = "opacity 0.5s ease";
    void resultDiv.offsetHeight;
    resultDiv.style.padding = "1.75rem";
    resultDiv.style.borderRadius = "8px";
    resultDiv.style.marginTop = "1.5rem";
    resultDiv.style.textAlign = "center";
    resultDiv.style.boxShadow = "0 2px 10px rgba(0,0,0,0.08)";
    resultDiv.style.border = isError ? "1px solid #fca5a5" : "1px solid #d1d5db";
    resultDiv.style.background = isError ? "#fee2e2" : "#f8fafc";
    resultDiv.style.color = isError ? "#991b1b" : "#111827";

    const valueEl = resultDiv.querySelector(".value");
    if (valueEl) {
      valueEl.style.fontSize = "2.2rem";
      valueEl.style.fontWeight = "700";
      valueEl.style.margin = "0";
    }

    const labelEl = resultDiv.querySelector(".label");
    if (labelEl) {
      labelEl.style.fontSize = "1.9rem";
      labelEl.style.margin = "0.5rem 0 0.75rem 0";
    }

    const noteEl = resultDiv.querySelector(".note");
    if (noteEl) {
      noteEl.style.fontSize = "1.5rem";
      noteEl.style.color = "#4b5563";
      noteEl.style.marginTop = "0.75rem";
    }

    requestAnimationFrame(() => {
      resultDiv.style.opacity = "1";
    });
  }
});